export default __webpack_public_path__ + "static/media/massup_m1.063b631e.png";